var ko = require('knockout');
var $ = require('jquery');

ko.components.register('video-course-receipt', {
  viewModel: require('./video-course-receipt'),
  template: require('./video-course-receipt.template')
});

// Attach component to elements with data-attribute
$('[data-video-course-receipt]').each(function() {
  ko.applyBindings({}, this);
});
